var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"main-panel"},[(_vm.showNavbar)?_c('top-navbar'):_vm._e(),_c('dashboard-content')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }